"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BallotVote;
(function (BallotVote) {
    BallotVote[BallotVote["Yay"] = 0] = "Yay";
    BallotVote[BallotVote["Nay"] = 1] = "Nay";
    BallotVote[BallotVote["Pass"] = 2] = "Pass";
})(BallotVote = exports.BallotVote || (exports.BallotVote = {}));
//# sourceMappingURL=TezosP2PMessageTypes.js.map